export const REASONS_IN = [
  { value: 'stock_received_no_invoice', label: 'Stock Received (No Invoice)' },
  { value: 'customer_return', label: 'Customer Return' },
  { value: 'transfer_in', label: 'Transfer In' },
  { value: 'stock_take_increase', label: 'Stock Take — Found Extra' },
  { value: 'manual_add', label: 'Manual Add' },
  { value: 'correction_increase', label: 'Correction (Increase)' },
];

export const REASONS_OUT = [
  { value: 'damaged', label: 'Damaged / Wastage' },
  { value: 'transfer_out', label: 'Transfer Out' },
  { value: 'stock_take_decrease', label: 'Stock Take — Shortage' },
  { value: 'manual_subtract', label: 'Manual Subtract' },
  { value: 'correction_decrease', label: 'Correction (Decrease)' },
  { value: 'theft_loss', label: 'Theft / Loss' },
  { value: 'sample_gift', label: 'Sample / Gift' },
];

export const ADJUSTMENT_TYPES = [
  { value: 'add', label: 'Add (+)', sign: '+' },
  { value: 'subtract', label: 'Subtract (−)', sign: '−' },
  { value: 'set', label: 'Set Exact Value', sign: '=' },
];

export const PI_STATUSES = {
  draft: { label: 'Draft', color: 'secondary' },
  pending: { label: 'Pending', color: 'warning' },
  partial: { label: 'Partially Received', color: 'info' },
  received: { label: 'Received', color: 'success' },
  cancelled: { label: 'Cancelled', color: 'danger' },
};


export const getReasonsForType = (type) => {
  if (type === 'subtract') return REASONS_OUT;
  if (type === 'add') return REASONS_IN;
  return [...REASONS_IN, ...REASONS_OUT];
};